import { useEffect, useState } from 'react'

import { useAppDispatch } from 'store'
import { PerformerActions } from 'store/pages/performer'

interface Props {
  codes: string[]
}

const useBulkPerformerData = (props: Props) => {
  const { codes } = props

  const dispatch = useAppDispatch()

  const [performersAlready, setPerformersAlready] = useState<boolean>(false)

  useEffect(() => {
    if (!performersAlready) {
      dispatch(PerformerActions.getBulkData({ codes }))
      setPerformersAlready(true)
    }
  }, [codes])
}

export default useBulkPerformerData
